function loadChattyLater() {
  const loadChatty = () => {
    const script = document.createElement('script');
    script.src = 'https://cdn-fe.chatty.net/scripttag/chatty-embed.min.js';
    script.defer = true;
    script.dataset.shopId = 'bxlsjs0482saycxvruy8';
    document.body.appendChild(script);
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadChatty, { timeout: 5000 });
  } else {
    setTimeout(loadChatty, 5000);
  }
}

// 如果 load 已经过了，直接执行
if (document.readyState === 'complete') {
  loadChattyLater();
} else {
  window.addEventListener('load', loadChattyLater, { once: true });
}